import React, {useEffect} from 'react';
import Tab from "react-bootstrap/lib/Tab";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import Nav from "react-bootstrap/lib/Nav";
import NavItem from "react-bootstrap/lib/NavItem";
import SystemRestoreTab from "./components/SystemRestoreTab";

function SettingsPage(props) {
    useEffect(() => {
        props.updateHeader("Settings", "")
    }, []);

    return (
        <Tab.Container id="left-tabs-example" defaultActiveKey="1">
            <Row className="clearfix">
                <Col sm={3}>
                    <Nav bsStyle="pills" stacked>
                        <NavItem eventKey="1"><h4>System Restore</h4></NavItem>
                    </Nav>
                </Col>
                <Col sm={6}>
                    <Tab.Content animation>
                        <Tab.Pane eventKey="1">
                            <SystemRestoreTab user={props.user}/>
                        </Tab.Pane>
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    )
}

export default SettingsPage
